export default __webpack_public_path__ + "static/media/help-rav-qa-2.e7415a60.png";